import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay, ease: "easeOut" }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ overline, title, text, center = false }) => (
  <Reveal className={center ? "text-center" : ""}>
    <p className="text-xs font-semibold uppercase tracking-[0.3em] text-gold mb-3">{overline}</p>
    <h2 className="text-2xl sm:text-3xl lg:text-4xl font-serif font-semibold tracking-tight text-white leading-snug">
      {title}
    </h2>
    {text && <p className="mt-4 text-base leading-relaxed text-slate-400 max-w-2xl mx-auto">{text}</p>}
  </Reveal>
);
